
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { TypeSurvey, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class TypeSurveyEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    typeSurvey: TypeSurvey;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getTypeSurvey()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getTypeSurvey(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.typeSurvey = data;
                this.onDataChanged.next(this.typeSurvey);
                resolve(this.typeSurvey);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('typeSurvey/' + this.routeParams.id).subscribe((res: TypeSurvey ) => {
                    this.typeSurvey = res;
                    this.onDataChanged.next(this.typeSurvey);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(typeSurvey): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('typeSurvey/', typeSurvey).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(typeSurvey): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('typeSurvey/', typeSurvey).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(typeSurvey): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('typeSurvey/' + typeSurvey.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): TypeSurvey {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
